import React from 'react';
import { config } from '@react-spring/web'
import useScrollTo from 'react-spring-scroll-to-hook'
import { clickTab } from '../../../../components/WETTabs';

const ErrorValidationSpan = ({ errMsg, elementId, keyEl }) => {
    const handleInteraction = () => {
        // Focus the element immediately, which allows typing without an extra click
        elementId.focus();
        
        // Perform other actions like tab navigation and scrolling
        if (keyEl === "ace_businessnumber") {
            clickTab(0);
        } else if (keyEl === "certificationField") {
            clickTab(2);
        } else {
            clickTab(1);
        }
        scrollTo(elementId, document.getElementById('global-alerts-container') ? -document.getElementById('global-alerts-container').offsetHeight - 2 : 0);
        
    };
    
    const handleKeyDown = (event) => {
        // Check if the pressed key is 'Enter' or 'Space'
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault(); // Prevent the default action of the key
            handleInteraction();
        }
    };
    
    const {scrollTo} = useScrollTo(config.molasses);
    return (
        <span 
          id={"span-"+keyEl}
          className="error-validation" 
          tabIndex="0" 
          onClick={handleInteraction}
          onKeyDown={handleKeyDown}
        >
          {errMsg}
        </span>
    );
};

export default ErrorValidationSpan;